import Context from '@component/common/src/util/Context';
import Logger from '@component/common/src/util/Logger';
import PageApp from '../../../app';

Context.add('quick-view', 'js', require.context('@feature/quick-view/src/views/bcom', true, /\.js$/));
Context.add('quick-view', 'hbs', require.context('@feature/quick-view/src/templates/bcom', true, /\.hbs$/));
Context.add('quick-view', 'scss', require.context('@feature/quick-view/src/scss/bcom', true, /\.scss$/));
Context.add('marketing-campaigns', 'hbs', require.context('../../templates/partials/bcom', true, /\.hbs$/));

require('@feature/quick-view');
require('@feature/pros-factory');

$('body').on('click', '.qvLauncher', function clicked(e) {
  e.preventDefault();
  e.stopPropagation();
  const prodId = $(this).data('id');
  PageApp.channel.trigger('quickView:launchQuickViewWithId', prodId, { isInitialLoad: true });
});
Logger.log('required qv');
